export default __webpack_public_path__ + "static/media/net.2bba7073.jpg";